<template>
  <input type="text" v-bind:value="value" @keypress="ensureNumericKeys" @keyup="formatAsCurrency" />
</template>

<script>
import numeral from "numeral";

export default {
  props: ["value"],

  model: {
    event: "keyup"
  },

  data() {
    return {};
  },

  methods: {
    formatAsCurrency($event) {
      this.$emit("keyup", numeral($event.target.value).format("0,0"));
    },
    ensureNumericKeys($event) {
      if (
        ($event.keyCode < 48 && $event.keyCode !== 46) ||
        $event.keyCode > 59
      ) {
        $event.preventDefault();
      }
    }
  }
};
</script>
